import { colors, Divider, mq } from 'plume-ui'
import { css } from '@emotion/react'
import React from 'react'

export const MarkdownTextDivider = () => {
  return (
    <Divider
      css={css`
        color: ${colors.gray60};
        margin: 45px 20px;
        width: 55px;

        ${mq.large} {
          margin: 45px 48px;
        }
      `}
    />
  )
}
